import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Tab,
  TabGroup,
  TabContent,
  TabMenu,
  TabContentGroup,
} from '@americanexpress/dls-react';
/* eslint-disable  import/no-cycle -- need */
import { constructChildStructure } from '../ChildConstructor';
import { getIcon } from './Icons';

/**
 * component return DLS Tab component
 * @param {*} props
 */
const DlsTab = ({
  cssProperties,
  tablabelOptions = [],
  tabContent = [],
  defaultSelectedTab,
  props,
}) => {
  /* eslint-enable  import/no-cycle -- need */
  const {
    formSubmissionPayload,
    setFormSubmissionPayload,
  } = props || {};

  const [selectedOptions, setSelectedOptions] = useState({});
  const [selectedOptionLabels, setSelectedOptionLabels] = useState({});

  useEffect(() => {
    const { length } = Object.entries(selectedOptions);
    setFormSubmissionPayload({
      ...formSubmissionPayload,
      ...{ elemId: null, selectedOptionsLength: length },
    });
  }, [selectedOptions]);

  return (
    <div className={cssProperties?.style || ''}>
      <TabGroup
        defaultSelectedTab={defaultSelectedTab}
        style={cssProperties?.tabGroupStyle || {}}
        className={cssProperties?.tabGroupClassName || ''}
      >
        <TabMenu
          style={cssProperties?.tabMenuStyle || {}}
          className={cssProperties?.tabMenuClassName || ''}
        >
          {tablabelOptions.map((tabOption) => (
            <Tab
              contentId={tabOption.contentId}
              id={tabOption.id}
              icon={tabOption.tabIcon ? getIcon(tabOption.tabIcon) : null}
              key={tabOption.id}
            >
              {tabOption.tabLabel}
            </Tab>
          ))}
        </TabMenu>
        <TabContentGroup className={cssProperties?.tabContentGroupClassName || ''}>
          {tabContent.map((tabContentItem) => (
            <TabContent
              id={tabContentItem.id}
              labelledBy={tabContentItem.labelledBy}
              key={tabContentItem.id}
            >
              {constructChildStructure(
                tabContentItem.childElements,
                {
                  ...props,
                  selectedOptions,
                  setSelectedOptions,
                  selectedOptionLabels,
                  setSelectedOptionLabels,
                },
                tabContentItem.id
              )}
            </TabContent>
          ))}
        </TabContentGroup>
      </TabGroup>
    </div>
  );
};

DlsTab.propTypes = {
  cssProperties: PropTypes.objectOf(PropTypes.shape),
  tablabelOptions: PropTypes.arrayOf(PropTypes.shape),
  tabContent: PropTypes.arrayOf(PropTypes.shape),
  defaultSelectedTab: PropTypes.string,
  props: PropTypes.objectOf(PropTypes.shape),
};

export default DlsTab;
